import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";

const safeRows = (value) => (Array.isArray(value) ? value : []);

const sanitizeFileName = (value) =>
  String(value || "protocol-export")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "") || "protocol-export";

const toCellValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "number") return value;
  if (typeof value === "boolean") return value ? "Yes" : "No";
  return String(value);
};

const mapRowsForExport = (columns, rows) =>
  safeRows(rows).map((row) =>
    columns.reduce((acc, column) => {
      const rawValue = typeof column.value === "function" ? column.value(row) : row?.[column.key];
      acc[column.label] = toCellValue(rawValue);
      return acc;
    }, {})
  );

export const exportRowsToExcel = ({ fileName, sheetName, columns, rows }) => {
  const worksheet = XLSX.utils.json_to_sheet(mapRowsForExport(columns, rows));
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, String(sheetName || "Sheet1").slice(0, 31));
  XLSX.writeFile(workbook, `${sanitizeFileName(fileName)}.xlsx`);
};

export const exportRowsToPdf = ({ fileName, title, columns, rows }) => {
  const doc = new jsPDF({
    orientation: columns.length > 5 ? "landscape" : "portrait",
    unit: "pt",
    format: "a4",
  });

  doc.setFontSize(15);
  doc.text(title || "Protocols Export", 40, 40);

  autoTable(doc, {
    startY: 56,
    head: [columns.map((column) => column.label)],
    body: safeRows(rows).map((row) =>
      columns.map((column) => {
        const rawValue = typeof column.value === "function" ? column.value(row) : row?.[column.key];
        return toCellValue(rawValue);
      })
    ),
    styles: {
      fontSize: 8,
      cellPadding: 4,
      overflow: "linebreak",
    },
    headStyles: {
      fillColor: [37, 99, 235],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [248, 250, 252],
    },
    margin: { top: 56, right: 40, bottom: 40, left: 40 },
  });

  doc.save(`${sanitizeFileName(fileName)}.pdf`);
};
